import React, { useState, useEffect } from "react";
import { Token_Generator } from "../actions/auth";


function RefreshToken() {
	// eslint-disable-next-line
	const [token, setToken] = useState(null);

	const fetchToken = async () => {
		// let body = {
		// 	clientid: localStorage.getItem("clientid"),
		// 	grant_type: "client_credentials",
		// 	clientsecret: localStorage.getItem("clientsecret"),
		// };
		const response = await Token_Generator();

		localStorage.setItem("token_gen1", JSON.stringify(response));
		setToken(response);
	};

	useEffect(() => {
		const intervalId = setInterval(() => {
			fetchToken();
		}, 58 * 60 * 1000);

		return () => clearInterval(intervalId);
	}, []);

	return <></>;
}
export default RefreshToken;
